/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-empty-function */
import { DecimalPipe } from '@angular/common';
import { Component, EventEmitter, forwardRef, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { IDataSelectAccount } from '@pacifico/interfaces/components.interface';

@Component({
	selector: 'app-select-account',
	templateUrl: './select-account.component.html',
	styleUrls: ['./select-account.component.scss'],
	providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => SelectAccountComponent), multi: true }]
})
export class SelectAccountComponent implements ControlValueAccessor, OnChanges {
	@Input() showAdditionalData = false;
	@Input() items: IDataSelectAccount[] = [];
	@Input() itemSelected: IDataSelectAccount | undefined;

	@Output() changeItem = new EventEmitter<IDataSelectAccount | undefined>();

	constructor(private _decimalPipe: DecimalPipe) {}

	private _onChange = (_value: IDataSelectAccount | undefined) => {};
	private _onTouched = () => {};

	breakDown = false;

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.items) {
			setTimeout(() => {
				// this.value = undefined;
			}, 0);
			this._onTouched();
			this._onChange(this.itemSelected);
			this.changeItem.emit(this.itemSelected);
		}
	}

	change(item: IDataSelectAccount): void {
		this.itemSelected = item;
		this._onTouched();
		this._onChange(this.itemSelected);
		this.changeItem.emit(this.itemSelected);
	}

	availableBalanceFormatted(item: IDataSelectAccount): string {
		return String(this._decimalPipe.transform(item.availableBalance, '1.2-2'));
	}

	breakDownSelect(): void {
		this.breakDown = !this.breakDown;
	}

	writeValue(value: IDataSelectAccount): void {
		this.itemSelected = value;
	}

	registerOnChange(fn: any): void {
		this._onChange = fn;
	}

	registerOnTouched(fn: any): void {
		this._onTouched = fn;
	}

	get value(): IDataSelectAccount {
		return this.itemSelected!;
	}

	set value(val: IDataSelectAccount | undefined) {
		this.itemSelected = val;
		this._onChange(val);
		this._onTouched();
	}
}
